import React from "react";

interface ButtonPrimaryProps {
  title: string;
  [key: string]: any; // Allows for additional props
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({ title, ...props }) => {
  return (
    <button
      className="group relative font-heading px-6 py-3 h-full w-full uppercase text-white font-semibold tracking-px bg-gradient-to-bl from-primary to-primaryHover overflow-hidden rounded-md transition-transform duration-500 active:scale-105"
      {...props} // Spread the additional props here
    >
      <div className="absolute top-0 left-0 transform -translate-x-full group-hover:-translate-x-0 h-full w-full transition ease-in-out duration-500 bg-primaryHover" />
      <p className="relative z-10">{title}</p>
    </button>
  );
};

export default ButtonPrimary;
